import React from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import DownloadIcon from '@mui/icons-material/Download';
import { API_URL } from '../../Constants';

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

function handlePhysicPromissoryAndBack() {
    window.location = '/commerce';
}

function handleDownloadPagare() {
    let nameFile = localStorage.getItem("pagareUuid")+ '.pdf';
    fetch(apiUrl + '/v1/s3/download?key=' + nameFile, {
        method: 'GET'
    }).then(resp => resp.blob())
        .then(blob => {
            console.log("blob" + blob);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = nameFile;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            window.location = '/commerce';
        })
        .catch(() => alert("oh no, algo salio mal!"));
}


let apiUrl = API_URL;

export default function DownloadPagare() {


    return (
        <React.Fragment>
            <Header />
            <Container maxWidth="md">
                <br />
                <br />
                <br />
                <Box sx={{ flexGrow: 1 }}>
                    <Stack spacing={12}>
                        <Grid></Grid>
                        <Grid container spacing={2}>
                            <Grid item xs />
                            <Grid item xs={7}>
                                <Stack spacing={8}>
                                    <h1 style={{ textAlign: 'center' }}>Crédito generado!</h1>
                                    <ButtonPrincipal variant="contained" onClick={handleDownloadPagare}>Descargar plan de pago y pagaré<DownloadIcon /></ButtonPrincipal>
                                    <ButtonPrincipal variant="contained" onClick={handlePhysicPromissoryAndBack} >Usar pagaré fisico y volver</ButtonPrincipal>
                                </Stack>
                            </Grid>
                            <Grid item xs />
                        </Grid>
                    </Stack>

                </Box>
            </Container>
        </React.Fragment>
    );
}